












import { defineComponent, PropType, ref } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import CreatorServiceItem from "@/features/CreatorService/components/CreatorServiceItem.vue";

export default defineComponent({
  name: "CreatorServiceRemoveConfirm",
  components: { BaseButton, BaseConfirm, CreatorServiceItem },
  props: {
    item: { type: Object as PropType<CreatorService>, default: undefined },
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const onConfirm = () => {
      loading.value = true;
      emit("confirm", () => (loading.value = false));
    };

    return {
      loading,
      onConfirm,
    };
  },
});
